import { ref, watch } from 'vue';

export default function useToasts(props) {
  const localToasts = ref(props.toasts ?? []);

  const addToast = (toast) => {
    localToasts.value.push(toast);
  };

  const addToasts = (toasts) => {
    for (let key in toasts) {
      localToasts.value.push(toasts[key]);
    }
  };

  watch(
    () => props.toasts,
    (newToasts) => (localToasts.value = newToasts)
  );

  return {
    addToast,
    addToasts,
    localToasts,
  };
}
